import { createTheme } from "@mui/material/styles";
import LineSeedJPRgWoff2 from './fonts/LINESeedJP_OTF_Rg.woff2';
import LineSeedJPBdWoff2 from './fonts/LINESeedJP_OTF_Bd.woff2';
import { jaJP } from '@mui/material/locale';

// フォントを設定
const fontFamily = [
  'LineSeed-JP',
].join(',');

const theme = createTheme(
  {
    typography: {
      fontFamily: fontFamily,
      //fontSize: 13, // 基本フォントサイズを13pxに設定（デフォルトは14px）
    },  
    palette: {
      primary: {
        light: '#ffdca3',
        main: '#ffbb00',
        dark: '#efa92a',
        contrastText: '#0d0d0d',
      },
      secondary: {
        light: '#fff5e5',
        main: '#ee7700',
        dark: '#d56a00',
        contrastText: '#fffff',
      },
      //background: {
      //  default: '#0d0d0d',
      //}, 
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'LineSeed-JP';
            font-style: normal;
            font-display: swap;
            font-weight: normal;
            src: local('LineSeed-JP'), local('LineSeed-JP-Regular'), url(${LineSeedJPRgWoff2}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'LineSeed-JP';
            font-style: normal;
            font-display: swap;
            font-weight: bold;
            src: local('LineSeed-JP'), local('LineSeed-JP-Bold'), url(${LineSeedJPBdWoff2}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
        `,
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: '#ffdca3',
            color: '#0d0d0d',
          }
        }
      },      
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "orange",
            "&$focused": {
              color: "blue"
            }
          }
        }
      },
      MuiToolbar: {
        styleOverrides: {
          dense: {
              height: 70,
              minHeight: 70,
              backgroundColor: '#ffdca3',
          }
        }
      },
    },
  },
  jaJP,
);

export default theme;
